module.exports = __webpack_public_path__ + "2231433f3a9d17af920d8285878f4d29.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/bg.png
// module id = 545
// module chunks = 0